import type { PublicApiKey } from '#packages/apilib';
import type { createCopyPasteApi } from './copyPasteWrapper';

export const CopyPasteApiKey: PublicApiKey<typeof createCopyPasteApi> = {
  name: 'CopyPasteApi',
  public: true,
};
